export const nav_arr = () => {
	return {
        list:[

            {
                name: "线索公海",
                route: "/clue",
                comp: "",
                comp_addr: "",
                has_child: 2,
                icon: "icon-scrm1",
                id: 101,
                page: [
                    {
                        name: "线索公海",
                        route: "",
                        comp: "",
                        comp_addr: "",
                        id: 4,
                        button: [ ],
                    },
                ],
            },
            {
                name: "客户微信",
                route: "/wechat",
                comp: "",
                comp_addr: "",
                has_child: 2,
                icon: "custom-wechat",
                id: 102,
                path:'/custom',
                page: [
                    {
                        name: "客户微信",
                        route: "",
                        comp: "",
                        comp_addr: "",
                        id: 4,
                        button: [ ],
                    },
                ],
            },
            // {
            //     name: "线索客户",
            //     route: "scrm-2",
            //     comp: "",
            //     comp_addr: "",
            //     has_child: 2,
            //     icon: "icon-scrm2",
            //     id: 102,
            //     url:'http://scrmapi.tjlhyg.com/index/Index/directPortalLogin',
            //     system:'scrm',
            //     page: [
            //         {
            //             name: "线索客户",
            //             route: "",
            //             comp: "",
            //             comp_addr: "",
            //             id: 4,
            //             button: [ ],
            //         },
            //     ],
            // },
            {
                name: "客户管理",
                route: "/custom",
                comp: "custom",
                comp_addr: "custom/custom-main",
                has_child: 2,
                icon: "icon3",
                path:'/custom',
                id: 1,
                page: [
                    {
                        name: "客户管理",
                        route: "",
                        comp: "",
                        comp_addr: "",
                        id: 2,
                        button: [ ],
                    },
                ],
            },
            {
                name: "客户群",
                route: "/wechat-group",
                comp: "",
                comp_addr: "",
                has_child: 222,
                icon: "custom-group",
                path:'/custom-group',
                id: 1,
                page: [
                    {
                        name: "客户群",
                        route: "",
                        comp: "",
                        comp_addr: "",
                        id: 222,
                        button: [ ],
                    },
                ],
            },
            {
                name: "销售机会",
                route: "/sellchance",
                comp: "sellchance",
                comp_addr: "sellChance/sellChance-main",
                has_child: 2,
                icon: "sellchance",
                id: 3,
                page: [
                    {
                        name: "销售机会",
                        route: "",
                        comp: "",
                        comp_addr: "",
                        id: 4,
                        button: [ ],
                    },
                ],
            },
        ],
        list1:[
            // {
            //     name: "客户管理",
            //     route: "/custom",
            //     comp: "custom",
            //     comp_addr: "custom/custom-main",
            //     has_child: 2,
            //     icon: "icon3",
            //     id: 3,
            //     page: [
            //         {
            //             name: "客户管理",
            //             route: "",
            //             comp: "",
            //             comp_addr: "",
            //             id: 19,
            //             button: [ ],
            //         },
            //     ],
            // },
            // {
            //     name: "销售机会",
            //     route: "/sellchance",
            //     comp: "sellchance",
            //     comp_addr: "sellChance/sellChance-main",
            //     has_child: 2,
            //     icon: "sellchance",
            //     id: 4,
            //     page: [
            //         {
            //             name: "销售机会",
            //             route: "",
            //             comp: "",
            //             comp_addr: "",
            //             id: 20,
            //             button: [ ],
            //         },
            //     ],
            // },
            {
                name: "合同管理",
                route: "/contract",
                comp: "contract",
                comp_addr: "contract/contract-main",
                has_child: 2,
                icon: "htgl",
                id: 5,
                page: [
                    {
                        name: "合同管理",
                        route: "",
                        comp: "",
                        comp_addr: "",
                        id: 6,
                        button: [ ],
                    },
                ],
            },
            {
                name: "回款记录",
                route: "/contractback",
                comp: "contractback",
                comp_addr: "contractBack/contractBack-main",
                has_child: 2,
                icon: "contract",
                id: 7,
                page: [
                    {
                        name: "回款记录",
                        route: "",
                        comp: "",
                        comp_addr: "",
                        id: 8,
                        button: [ ],
                    },
                ],
            },
            {
                name: "费用申请",
                route: "/constapply",
                comp: "constapply",
                comp_addr: "constApply/constApply-main",
                has_child: 2,
                icon: "apply",
                id: 9,
                page: [
                    {
                        name: "费用申请",
                        route: "",
                        comp: "",
                        comp_addr: "",
                        id: 10,
                        button: [ ],
                    },
                ],
            },
            {
                name: "房屋合同",
                route: "/housecontract",
                comp: "housecontract",
                comp_addr: "houseContract/house-contract",
                has_child: 2,
                icon: "housecontract",
                id: 11,
                page: [
                    {
                        name: "房屋合同",
                        route: "",
                        comp: "",
                        comp_addr: "",
                        id: 12,
                        button: [ ],
                    },
                ],
            },
            {
                name: "房屋回款",
                route: "/housecollection",
                comp: "housecollection",
                comp_addr: "houseCollection/house-collection",
                has_child: 2,
                icon: "housecollection",
                id: 13,
                page: [
                    {
                        name: "房屋回款",
                        route: "",
                        comp: "",
                        comp_addr: "",
                        id: 14,
                        button: [ ],
                    },
                ],
            },
            {
                name: "开票管理",
                route: "/openbill",
                comp: "openbill",
                comp_addr: "openBill/openBill-main",
                has_child: 2,
                icon: "openbill",
                id: 15,
                page: [
                    {
                        name: "开票管理",
                        route: "",
                        comp: "",
                        comp_addr: "",
                        id: 16,
                        button: [ ],
                    },
                ],
            },
            // {
            //     name: "渠道管理",
            //     route: "/channel",
            //     comp: "channel",
            //     comp_addr: "channel/channel-main",
            //     has_child: 2,
            //     icon: "channel",
            //     id: 17,
            //     page: [
            //         {
            //             name: "渠道管理",
            //             route: "/channel",
            //             comp: "channel",
            //             comp_addr: "channel/channel-main",
            //             id: 18,
            //             button: [ ],
            //         },
            //     ],
            // },
            // {
            //     name: "平台管理",
            //     route: "/terrace",
            //     comp: "",
            //     comp_addr: "",
            //     has_child: 1,
            //     icon: "ptgl",
            //     id: 1,
            //     page: [
            //         {
            //             name: "成员管理",
            //             route: "/terrace/member",
            //             comp: "terrace/member",
            //             comp_addr: "terrace/member-terrace",
            //             id: 11,
            //             button: [ ],
            //         },
            //         {
            //             name: "部门管理",
            //             route: "/terrace/depart",
            //             comp: "terrace/depart",
            //             comp_addr: "terrace/depart-terrace",
            //             id: 12,
            //             button: [ ],
            //         },
            //         {
            //             name: "角色管理",
            //             route: "/terrace/role",
            //             comp: "terrace/role",
            //             comp_addr: "terrace/role-terrace",
            //             id: 13,
            //             button: [ ],
            //         },
            //         {
            //             name: "权限管理",
            //             route: "/terrace/power",
            //             comp: "terrace/power",
            //             comp_addr: "terrace/power-terrace",
            //             id: 14,
            //             button: ["edit", "create_role"],
            //         },
            //         {
            //             name: "个人中心",
            //             route: "/terrace/personal",
            //             comp: "terrace/personal",
            //             comp_addr: "terrace/personal-terrace",
            //             id: 15,
            //             button: ["edit", "person"],
            //         },
            //     ],
            // },

            {
                name: "数据列表",
                route: "/data",
                comp: "data",
                comp_addr: "dataList/data-main",
                has_child: 2,
                icon: "data",
                id: 19,
                page: [
                    {
                        name: "数据列表",
                        route: "",
                        comp: "",
                        comp_addr: "",
                        id: 20,
                        button: [],
                    },
                ],
            }
        ],
        list2:[
            {
                id: 21,
                name: '数据统计',
                icon: 'fw-icon1',
                route: '/tj/douyin',
                has_child:2,
                page:[]
            },
            {
                id: 100,
                name: '基础素材',
                icon: 'fw-icon2',
                route: '基础',
                has_child: 1,
                page: [
                    // {
                    //     name: '素材库',
                    //     // route: '/developing1',
                    //     route: '/SourceMaterial',
                    //     id: 101,
                    //     breadcrumb_father: '基础素材',
                    //     button:[],
                    // },
                    {
                        name: '轮播图',
                        route: '/qifu/carousel',
                        id: 123,
                        breadcrumb_father: '小程序管理',
                        button:[],
                    },
                    {
                        name: '雷达文件',
                        route: '/developing2',
                        id: 102,
                        breadcrumb_father: '基础素材',
                        button:[],
                    },
                    // {
                    //     name: '宣传视频',
                    //     route: '/developing3',
                    //     id: 103,
                    //     breadcrumb_father: '基础素材'
                    // },
                    {
                        name: '政策资质',
                        route: '/policy',
                        id: 104,
                        breadcrumb_father: '基础素材',
                        button:[],
                    },
                    {
                        name: '文章发布',
                        // route: '/developing4',
                        route:'/ArticleRelease',
                        id: 105,
                        breadcrumb_father: '基础素材',
                        button:[],
                    },
                ],
            },
            {
                id: 106,
                name: '运营管理',
                icon: 'fw-icon3',
                route: '运营',
                has_child: 1,
                page: [
                    {
                        name: '朋友圈',
                        route: '/developing5',
                        id: 107,
                        breadcrumb_father: '运营管理',
                        button:[],
                    },
                    {
                        name: '活动预约',
                        // route: '/developing6',
                        route:'/activities',
                        id: 107,
                        breadcrumb_father: '运营管理',
                        button:[],
                    },
                    {
                        name: '活动客户',
                        route: '/person/customerActive',
                        id: 130,
                        breadcrumb_father: '运营管理',
                        button:[],
                    },
                    {
                        name: '问答管理',
                        route: '/info/question',
                        id: 109,
                        breadcrumb_father: '运营管理',
                        button:[],
                    },
                    {
                        name: '企业话术库',
                        // route: '/developing7',
                        route: '/BizCommLib',
                        id: 110,
                        breadcrumb_father: '运营管理',
                        button:[],
                    },
                    {
                        name: '积分兑换',
                        route: '/score/coupon',
                        id: 111,
                        breadcrumb_father: '运营管理',
                        button:[],
                    },
                    {
                        name: '积分兑换V2',
                        route: '/points',
                        id: 132,
                        breadcrumb_father: '运营管理',
                        button:[],
                    },
                    {
                        name: '客服管理',
                        route: '/person/customerService',
                        id: 112,
                        breadcrumb_father: '运营管理',
                        button:[],
                    },
                ],
            },
            // {
            //     id: 113,
            //     name: '企微风控',
            //     icon: 'fw-icon4',
            //     route: '企微',
            //     has_child: 1,
            //     page: [
            //         {
            //             name: '敏感词',
            //             route: '/developing8',
            //             id: 114,
            //             breadcrumb_father: '企微风控',
            //             button:[],
            //         },
            //         {
            //             name: '聊天记录',
            //             route: '/developing9',
            //             id: 115,
            //             breadcrumb_father: '企微风控',
            //             button:[],
            //         },
            //     ],
            // },

            {
                id: 116,
                name: '网站管理',
                icon: 'fw-icon5',
                route: '网站',
                has_child: 1,
                page: [
                    {
                        name: '业务体系',
                        route: '/binhang/business',
                        id: 117,
                        breadcrumb_father: '网站管理',
                        button:[],
                    },
                    {
                        name: '客户案例',
                        route: '/binhang/cases',
                        id: 118,
                        breadcrumb_father: '网站管理',
                        button:[],
                    },
                    {
                        name: '服务中心',
                        route: '/binhang/service',
                        id: 119,
                        breadcrumb_father: '网站管理',
                        button:[],
                    },
                    {
                        name: '生态联盟',
                        route: '/binhang/alliance',
                        id: 120,
                        breadcrumb_father: '网站管理',
                        button:[],
                    },
                    {
                        name: '关于企业',
                        route: '/binhang/about',
                        id: 121,
                        breadcrumb_father: '网站管理',
                        button:[],
                    },
                ],
            },
            {
                id: 122,
                name: '小程序管理',
                icon: 'fw-icon6',
                route: '小程序',
                has_child: 1,
                page: [
                    {
                        name: '企业信息',
                        route: '/manage/binhang',
                        id: 124,
                        breadcrumb_father: '小程序管理',
                        button:[],
                    },
                    {
                        name: '关于我们',
                        route: '/info/about',
                        id: 125,
                        breadcrumb_father: '小程序管理',
                        button:[],
                    },
                    {
                        name: '企服管理',
                        route: '/qifu/service',
                        id: 126,
                        breadcrumb_father: '小程序管理',
                        button:[],
                    },
                    {
                        name: '招商管理',
                        route: '/manage/merchant',
                        id: 127,
                        breadcrumb_father: '小程序管理',
                        button:[],
                    },
                    {
                        name: '活动管理',
                        route: '/info/activity',
                        id: 128,
                        breadcrumb_father: '小程序管理',
                        button:[],
                    },
                    {
                        name: '反馈列表',
                        route: '/person/feedback',
                        id: 129,
                        breadcrumb_father: '小程序管理',
                        button:[],
                    },
                ],
            },
            // {
            //     id: 22,
            //     name: '企业信息',
            //     icon: 'binhang',
            //     route: '',
            //     has_child: 1,
            //     page: [
            //         {
            //             name: '轮播图',
            //             route: '/qifu/carousel',
            //             id: 23,
            //             breadcrumb_father: '企业信息'
            //         },
            //         {
            //             name: '企业信息',
            //             route: '/manage/binhang',
            //             id: 24,
            //             breadcrumb_father: '企业信息'
            //         },
            //         {
            //             name: '关于我们',
            //             route: '/info/about',
            //             id: 25,
            //             breadcrumb_father: '企业信息'
            //         },
            //     ],
            // },
            // {
            //     id: 26,
            //     name: '企业官网',
            //     icon: 'official',
            //     route: 'official',
            //     has_child: 1,
            //     page: [
            //         {
            //             name: '业务体系',
            //             route: '/binhang/business',
            //             id: 27,
            //             breadcrumb_father: '企业官网'
            //         },
            //         {
            //             name: '客户案例',
            //             route: '/binhang/cases',
            //             id: 28,
            //             breadcrumb_father: '企业官网'
            //         },
            //         {
            //             name: '服务中心',
            //             route: '/binhang/service',
            //             id: 29,
            //             breadcrumb_father: '企业官网'
            //         },
            //         {
            //             name: '生态联盟',
            //             route: '/binhang/alliance',
            //             id: 31,
            //             breadcrumb_father: '企业官网'
            //         },
            //         {
            //             name: '关于企业',
            //             route: '/binhang/about',
            //             id: 32,
            //             breadcrumb_father: '企业官网'
            //         },
            //     ],
            // },
            // {
            //     id: 33,
            //     name: '企服管理',
            //     icon: 'qifu',
            //     route: '/qifu/service',
            // },
            // {
            //     id: 34,
            //     name: '招商管理',
            //     icon: 'merchant',
            //     route: '/manage/merchant',
            // },
            // {
            //     id: 35,
            //     name: '咨讯管理',
            //     icon: 'info',
            //     route: 'info',
            //     has_child: 1,
            //     page: [
            //         {
            //             name: '活动管理',
            //             route: '/info/activity',
            //             id: 36,
            //             breadcrumb_father: '咨讯管理'
            //         },
            //         {
            //             name: '公开课',
            //             route: '/info/lesson',
            //             id: 37,
            //             breadcrumb_father: '咨讯管理'
            //         },
            //         {
            //             name: '问答管理',
            //             route: '/info/question',
            //             id: 38,
            //             breadcrumb_father: '咨讯管理'
            //         },
            //         {
            //             name: '官网咨讯',
            //             route: '/info/message',
            //             id: 39,
            //             breadcrumb_father: '咨讯管理'
            //         },
            //     ]
            // },
            // {
            //     id: 40,
            //     name: '积分管理',
            //     icon: 'score',
            //     route: 'score',
            //     has_child: 1,
            //     page: [
            //         {
            //             name: '优惠卷列表',
            //             route: '/score/coupon',
            //             id: 41,
            //             breadcrumb_father: '积分管理'
            //         },
            //     ]
            // },
            // {
            //     id: 42,
            //     name: '客户服务',
            //     icon: 'xc-user',
            //     route: ' ',
            //     has_child: 1,
            //     page: [
            //         {
            //             name: '客户列表',
            //             route: '/person/customer',
            //             id: 43,
            //             breadcrumb_father: '客户服务'
            //         },
            //         {
            //             name: '活动客户',
            //             route: '/person/customerActive',
            //             id: 44,
            //             breadcrumb_father: '客户服务'
            //         },
            //         {
            //             name: '客服列表',
            //             route: '/person/customerService',
            //             id: 45,
            //             breadcrumb_father: '客户服务'
            //         },
            //         {
            //             name: '反馈列表',
            //             route: '/person/feedback',
            //             id: 46,
            //             breadcrumb_father: '客户服务'
            //         },
            //         {
            //             name: '官网客户',
            //             route: '/info/userinfo',
            //             id: 47,
            //             breadcrumb_father: '客户服务'
            //         }
            //     ]
            // },

        ],
        list3:[

            {
                comp: "field/list",
                comp_addr: "field/field-list",
                has_child: 2,
                icon: "icon-field",
                id: 49,
                name: "外勤管理",
                page: [],
                path: "/field/list",
                route: "/field/list",
            },

            {
                comp: "field/process",
                comp_addr: "field/process-manage",
                has_child: 2,
                icon: "icon-process",
                id: 50,
                name: "外勤流程",
                page: [],
                path: "/field/process",
                route: "/field/process",
            },
            {
                comp: "house",
                comp_addr: "house/house-main",
                has_child: 2,
                icon: "house",
                id: 51,
                name: "房号管理",
                page: [],
                path: "/house",
                route: "/house",
            },
            {
                comp: "bill/billdetail",
                comp_addr: "bill/bill-detail",
                has_child: 2,
                icon: "icon-hosue",
                id: 103,
                name: "房屋租赁",
                page: [],
                path: "/houselease",
                route: "/houselease",
            },
            {
                comp: "bill/billdetail",
                comp_addr: "bill/bill-detail",
                has_child: 2,
                icon: "icon-bill1",
                id: 104,
                name: "开票明细",
                page: [],
                path: "/house",
                route: "/bill/billdetail",
            },
            {
                comp: "bill/personaldetail",
                comp_addr: "message/system-message",
                has_child: 2,
                icon: "icon-bill2",
                id: 105,
                name: "个体明细",
                page: [],
                path: "/bill/personaldetail",
                route: "/bill/personaldetail",
            },
            // {
            //     name:"开票管理",
            //     route:"bill",
            //     comp:"",
            //     comp_addr:"",
            //     has_child:1,
            //     icon:"bill",
            //     id:52,
            //     page:[
            //         {
            //             name:"开票明细",
            //             parent:"开票管理",
            //             route:"/bill/billdetail",
            //             comp:"bill/billdetail",
            //             comp_addr:"bill/bill-detail",
            //             id:53,
            //             button:["select","reset","create","edit","del","buyer_select","buyer_create","buyer_edit","buyer_del","list"]
            //         },
            //         {
            //             name:"个体明细",
            //             parent:"开票管理",
            //             route:"/bill/personaldetail",
            //             comp:"bill/personaldetail",
            //             comp_addr:"message/system-message",
            //             id:54,
            //             button:["select","reset","create","big_edit","small_edit","del","list"]
            //         }
            //     ]
            // },
            {
                name:"项目管理",
                route:"projmgmt",
                comp:"",
                comp_addr:"",
                has_child:1,
                icon:"projmgmt",
                id:55,
                page:[
                    {
                        name:"项目清单",
                        parent:"项目管理",
                        route:"/projmgmt/index",
                        comp:"projmgmt/index",
                        comp_addr:"",
                        id:56,
                        button:["select","reset","import","create"]
                    },
                    {
                        name:"我的项目",
                        parent:"项目管理",
                        route:"/projmgmt/myprojmgmt",
                        comp:"projmgmt/myprojmgmt",
                        comp_addr:"",
                        id:57,
                        button:["select","reset","import","create","export"]
                    },
                    {
                        name:"工作清单",
                        parent:"项目管理",
                        route:"/projmgmt/mytask",
                        comp:"projmgmt/mytask",
                        comp_addr:"",
                        id:58,
                        button:["select","reset","create","edit","del"]
                    },
                    {
                        name:"项目统计",
                        parent:"项目管理",
                        route:"/projmgmt/projmgmtcount",
                        comp:"projmgmt/projmgmtcount",
                        comp_addr:"",
                        id:59,
                        button:["select","reset","create","edit","view","status","export"]
                    }
                ]
            },
            {
                comp: "",
                comp_addr: "",
                has_child: 2,
                icon: "icon-property",
                id: 106,
                name: "资产管理",
                page: [],
                path: "/property",
                route: "/property",
                url:'https://zcgl.lianghang.cc/',
            },
            {
                comp: "bill/personaldetail",
                comp_addr: "message/system-message",
                has_child: 2,
                icon: "icon-property2",
                id: 107,
                name: "物业管理",
                page: [],
                path: "/system-message",
                route: "/system-message",
                url:'https://bhwy.tjbinhang.cn/web/#/login'
            },
            // {
            //     name:"组织架构",
            //     route:"terrace",
            //     comp:"",
            //     comp_addr:"",
            //     has_child:1,
            //     icon:"organization",
            //     id:1,
            //     page:[
            //         {
            //             name:"成员管理",
            //             parent:"组织架构",
            //             route:"/terrace/member",
            //             comp:"terrace/member",
            //             comp_addr:"terrace/member-terrace",
            //             id:11,
            //             button:["select","reset","batch_del","export","create","edit","del","enable"]
            //         },
            //         {
            //             name:"部门管理",
            //             parent:"组织架构",
            //             route:"/terrace/depart",
            //             comp:"terrace/depart",
            //             comp_addr:"terrace/depart-terrace",
            //             id:12,
            //             button:["select","reset","relevance","cancel","create","edit","del"]
            //         },
            //         {
            //             name:"角色管理",
            //             parent:"组织架构",
            //             route:"/terrace/role",
            //             comp:"terrace/role",
            //             comp_addr:"terrace/role-terrace",
            //             id:13,
            //             button:["select","reset","relevance","cancel","create","edit","del"]
            //         },
            //         {
            //             name:"权限管理",
            //             parent:"组织架构",
            //             route:"/terrace/power",
            //             comp:"terrace/power",
            //             comp_addr:"terrace/power-terrace",
            //             id:14,
            //             button:["edit","create_role"]
            //         }
            //     ]
            // },
            // {
            //     name:"系统设置",
            //     route:"system"
            //     ,comp:"",
            //     comp_addr:"",
            //     has_child:1,
            //     icon:"system",
            //     id:155,
            //     page:[
            //         {
            //             name:"操作日志",
            //             parent:"系统设置",
            //             route:"/system/log",
            //             comp:"system/log",
            //             comp_addr:"system/system-log",
            //             id:156,
            //             button:["select","reset"]
            //         },
            //         {
            //             name:"参数管理",
            //             parent:"系统设置",
            //             route:"/out/system/params",
            //             comp:"system/params",
            //             comp_addr:"system/system-params",
            //             id:157,
            //             button:["create","edit","delete"]
            //         }
            //     ]
            // },
            // {
            //     name:"消息中心",
            //     route:"message",
            //     comp:"",
            //     comp_addr:"",
            //     has_child:1,
            //     icon:"message",
            //     id:158,
            //     page:[
            //         {
            //             name:"待办列表",
            //             parent:"消息中心",
            //             route:"/out/message/todo",
            //             comp:"message/todo",
            //             comp_addr:"message/todo-list",
            //             id:159,
            //             button:["select","reset","handle"]
            //         },
            //         {
            //             name:"系统消息",
            //             parent:"消息中心",
            //             route:"/out/message/notice",
            //             comp:"message/notice",
            //             comp_addr:"message/system-message",
            //             id:160,button:["select","reset","edit"]
            //         }
            //     ]
            // },
            // {
            //     name:"个人中心",
            //     route:"/terrace/personal",
            //     comp:"terrace/personal",
            //     comp_addr:"terrace/personal-terrace",
            //     has_child:2,
            //     icon:"personal",
            //     id:15,
            //     page:[
            //         {
            //             name:"个人中心",
            //             parent:"个人中心",
            //             route:"",
            //             comp:"",
            //             comp_addr:""
            //             ,id:142,
            //             button:["edit"]
            //         }
            //     ]
            // }
        ],
        list4:[
            {
                name: "系统消息",
                route: "/message",
                comp: "message",
                comp_addr: "message/system-message",
                has_child: 2,
                icon: "icon-message",
                id: 60,
                page: [
                    {
                        name: "系统消息",
                        route: "",
                        comp: "",
                        comp_addr: "",
                        id: 61,
                        button: [ ],
                    },
                ],
            },
            {
                name: "系统公告",
                route: "/notice",
                comp: "notice",
                comp_addr: "message/system-notice",
                has_child: 2,
                icon: "icon-report",
                id: 62,
                page: [
                    {
                        name: "系统公告",
                        route: "",
                        comp: "",
                        comp_addr: "",
                        id: 63,
                        button: [ ],
                    },
                ],
            },
            {
                name: "待办事项",
                route: "/todolist",
                comp: "todolist",
                comp_addr: "custom/custom-main",
                has_child: 2,
                icon: "icon-todo",
                id: 64,
                page: [
                    {
                        name: "待办事项",
                        route: "",
                        comp: "",
                        comp_addr: "",
                        id: 65,
                        button: [ ],
                    },
                ],
            },
            // {
            //     name: "消息中心",
            //     route: "/message",
            //     comp: "",
            //     comp_addr: "",
            //     has_child: 1,
            //     icon: "icon2",
            //     id: 2,
            //     page: [
            //         {
            //             name: "系统消息",
            //             route: "/message",
            //             comp: "message",
            //             comp_addr: "message/system-message",
            //             id: 16,
            //             button: ["select", "reset", "edit", "enable", "template"],
            //         },
            //         {
            //             name: "系统公告",
            //             route: "/notice",
            //             comp: "notice",
            //             comp_addr: "message/system-notice",
            //             id: 17,
            //             button: ["select", "reset", "craete", "edit"],
            //         },
            //         {
            //             name: "待办事项",
            //             route: "/todolist",
            //             comp: "todolist",
            //             comp_addr: "message/todo-list",
            //             id: 18,
            //             button: ["select", "reset", "handle"],
            //         },
            //     ],
            // },
        ],
        list5:[
            {
                name: "成员管理",
                route: "/terrace/member",
                comp: "terrace/member",
                comp_addr: "terrace/member-terrace",
                has_child: 2,
                icon: "icon-custom",
                id: 66,
                page: [
                    {
                        name: "成员管理",
                        route: "",
                        comp: "",
                        comp_addr: "",
                        id: 67,
                        button: [ ],
                    },
                ],
            },
            {
                name: "部门管理",
                route: "/terrace/depart",
                comp: "terrace/depart",
                comp_addr: "terrace/depart-terrace",
                has_child: 2,
                icon: "icon-branch",
                id: 68,
                page: [
                    {
                        name: "部门管理",
                        route: "",
                        comp: "",
                        comp_addr: "",
                        id: 69,
                        button: [ ],
                    },
                ],
            },
            {
                name: "角色管理",
                route: "/terrace/role",
                comp: "terrace/role",
                comp_addr: "terrace/role-terrace",
                has_child: 2,
                icon: "icon-role",
                id: 70,
                page: [
                    {
                        name: "角色管理",
                        route: "",
                        comp: "",
                        comp_addr: "",
                        id: 71,
                        button: [ ],
                    },
                ],
            },
            {
                name: "权限管理",
                route: "/terrace/power",
                comp: "terrace/power",
                comp_addr: "terrace/power-terrace",
                has_child: 2,
                icon: "icon-power",
                id: 72,
                page: [
                    {
                        name: "权限管理",
                        route: "",
                        comp: "",
                        comp_addr: "",
                        id: 73,
                        button: [ ],
                    },
                ],
            },
            {
                name: "个人中心",
                route: "/terrace/personal",
                comp: "terrace/personal",
                comp_addr: "terrace/personal-terrace",
                has_child: 2,
                icon: "icon-personal",
                id: 74,
                page: [
                    {
                        name: "个人中心",
                        route: "",
                        comp: "",
                        comp_addr: "",
                        id: 19,
                        button: [ ],
                    },
                ],
            },
        ],
        list6:[
            {
                name: "操作日志",
                route: "/systemdate",
                comp: "systemdate",
                comp_addr: "system/system-main",
                has_child: 2,
                icon: "icon-date",
                id: 75,
                page: [
                    {
                        name: "操作日志",
                        route: "",
                        comp: "",
                        comp_addr: "",
                        id: 76,
                        button: [ ],
                    },
                ],
            },
            {
                name: "开票人设置",
                route: "/system/companyset",
                comp: "system/companyset",
                comp_addr: "system/company-set",
                has_child: 2,
                icon: "icon-bill",
                id: 77,
                page: [
                    {
                        name: "开票人设置",
                        route: "",
                        comp: "",
                        comp_addr: "",
                        id: 78,
                        button: [ ],
                    },
                ],
            },
            {
                name: "参数管理",
                route: "/system/params",
                comp: "system/params",
                comp_addr: "system/params-manage",
                has_child: 2,
                icon: "icon-params",
                id: 79,
                page: [
                    {
                        name: "参数管理",
                        route: "",
                        comp: "",
                        comp_addr: "",
                        id: 80,
                        button: [ ],
                    },
                ],
            },
            // {
            //     name: "系统设置",
            //     route: "/system",
            //     comp: "",
            //     comp_addr: "",
            //     has_child: 1,
            //     icon: "icon4",
            //     id: 10,
            //     page: [
            //         {
            //             name: "操作日志",
            //             route: "/systemdate",
            //             comp: "systemdate",
            //             comp_addr: "system/system-main",
            //             id: 26,
            //             button: [],
            //         },
            //         {
            //             name: "开票人设置",
            //             route: "/system/companyset",
            //             comp: "system/companyset",
            //             comp_addr: "system/company-set",
            //             id: 153,
            //             button: ["create", "select", "edit", "del", "reset"],
            //         },
            //         {
            //             name: "参数管理",
            //             route: "/system/params",
            //             comp: "system/params",
            //             comp_addr: "system/params-manage",
            //             id: 169,
            //             button: ["create", "edit", "del"],
            //         },
            //     ],
            // },
        ],
    }
}



// [
//     {name: "自定义查询", route: "/CustomQuery", comp: "/CustomQuery",comp_addr:"CustomQuery/index",has_child:2,icon:"icon-CustomQuery",id:201,plant_type:10,page:[]},
//     {name: "跟进记录", route: "/followRecord", comp: "followRecord",comp_addr:"custom-follow/custom-follow-main",has_child:2,icon:"icon-follow",id:202,plant_type:3,page:[]},
//     {name: "外勤模板", route: "/field/template", comp: "template",comp_addr:"field/template-main",has_child:2,icon:"icon-wq-model",id:203,plant_type:2,page:[]},
//     {name: "物业门户", route: "/dashboard", comp: "dashboard",comp_addr:"wuye-gateway/gateway-main",has_child:2,icon:"icon-wymh",id:204,plant_type:11,page:[]},
//     {name: "租赁管理", route: "/lease", comp: "",comp_addr:"",has_child:1,icon:"icon-lease",id:205,plant_type:11,page:[
//         {name: "费用设置", parent: "租赁管理", route: "/expense/setting", comp: "expense-setting", comp_addr: "wuye-lease/expense-setting", id: 206,button:[]},
//         {name: "缴费明细", parent: "租赁管理", route: "/expense/detail", comp: "payment-detail", comp_addr: "wuye-lease/payment-detail", id: 207,button:[]},
//         {name: "房屋租赁", parent: "租赁管理", route: "/houselease", comp: "houselease-main", comp_addr: "houselease/houselease-main", id: 208,button:[]},
//     ]},
//     {name: "安防管理", route: "/wuye-security", comp: "",comp_addr:"",has_child:1,icon:"icon-security",id:209,plant_type:11,page:[
//         {name: "访客登记", parent: "安防管理", route: "/wuye-security/visitor-register", comp: "visitor-register", comp_addr: "wuye-security/visitor-register", id: 210,button:[]},
//         {name: "人员记录", parent: "安防管理", route: "/wuye-security/staff-record", comp: "staff-record", comp_addr: "wuye-security/staff-record", id: 211,button:[]},
//         {name: "车辆登记", parent: "安防管理", route: "/wuye-security/vehicle-register", comp: "vehicle-register", comp_addr: "wuye-security/vehicle-register", id: 212,button:[]},
//         {name: "车辆记录", parent: "安防管理", route: "/wuye-security/vehicle-record", comp: "vehicle-record", comp_addr: "wuye-security/vehicle-record", id: 213,button:[]},
//     ]},
//     {name: "能源抄表", route: "/energy/bankreceipt", comp: "energy-meter-reading", comp_addr: "wuye-energy/bankreceipt",has_child:2,icon:"icon-energy",id:230,plant_type:11,page:[
//         // {name: "水电抄表", parent: "能源抄表", route: "/energy/bankreceipt", comp: "energy-meter-reading", comp_addr: "wuye-energy/bankreceipt", id: 215,button:[]},
//     ]},
//     {name: "报修管理", route: "/repair", comp: "",comp_addr:"",has_child:1,icon:"icon-repairreport",id:240,plant_type:11,page:[
//         {name: "工单管理", parent: "报修管理", route: "/repairreport/itemList", comp: "itemList", comp_addr: "wuye-repair/itemList", id: 241,button:[]},
//         {name: "工单设置", parent: "报修管理", route: "/repairreport/myproject", comp: "myproject", comp_addr: "wuye-repair/myproject", id: 242,button:[]},
//     ]},
//     {name: "投诉反馈", route: "/complaint", comp: "",comp_addr:"",has_child:1,icon:"icon-complaint",id:250,plant_type:11,page:[
//         {name: "投诉记录", parent: "投诉反馈", route: "/complaint/record", comp: "record", comp_addr: "wuye-complaint/record", id: 244,button:[]},
//         {name: "意见反馈", parent: "投诉反馈", route: "/complaint/feedback", comp: "feedback", comp_addr: "wuye-complaint/feedback", id: 245,button:[]},
//         {name: "投票调查", parent: "投诉反馈", route: "/complaint/initiatevoting", comp: "initiatevoting", comp_addr: "wuye-complaint/initiatevoting", id: 246,button:[]},
//     ]},
// ]